(function (app) {

    //FilterTypes:
    //  - null means that the user will be selecting multiple values for a field that isn't an array. 
    //      ex. selecting multiple gender options when a client has only one value for gender.
    //  - "array" means that two arrays will be compared
    //  - "string" means we'll be doing comparison operations specific to string values
    //  - "comparison" means we'll be doing doing regular comparisons (>, =, <)

    app.constant("reportFields",
        {
            Client: [
                {
                    Name: "Prefix",
                    DisplayName: "Title",
                    PluralName: "Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "FirstName",
                    DisplayName: "First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "MiddleName",
                    DisplayName: "Middle Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "LastName",
                    DisplayName: "Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Nickname",
                    DisplayName: "Nickname",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Age",
                    DisplayName: "Age",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "DateOfBirth",
                    DisplayName: "Date Of Birth",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "Advisor",
                    ConditionName: "AdvisorId",
                    DisplayName: "Advisor",
                    PluralName: "Advisors",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "PhoneNumber",
                    DisplayName: "Phone Number",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "EmailAddress",
                    DisplayName: "Email Address",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "PhysicalAddress",
                    DisplayName: "Full Physical Address",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "StreetAddress1",
                    DisplayName: "Street Address",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "StreetAddress2",
                    DisplayName: "Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "City",
                    DisplayName: "City",
                    PluralName: "Cities",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "StateCode",
                    DisplayName: "State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "PostalCode",
                    DisplayName: "Postal Code",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "Aum",
                    DisplayName: "AUM",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalIssuedPremium",
                    DisplayName: "Total Issued Premium",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalCases",
                    DisplayName: "Total Cases",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalTasks",
                    DisplayName: "Total Tasks",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalAppointments",
                    DisplayName: "Total Appointments",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "Tags",
                    DisplayName: "Tags",
                    Type: "string",
                    FilterType: "array"
                },
                {
                    Name: "Gender",
                    DisplayName: "Gender",
                    PluralName: "Genders",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "Ssn",
                    DisplayName: "SSN",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Occupation",
                    DisplayName: "Occupation",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Status",
                    ConditionName: "StatusId",
                    DisplayName: "Status",
                    PluralName: "Statuses",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "TaxBracket",
                    DisplayName: "Tax Bracket",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "TaxFilingStatus",
                    DisplayName: "Tax Filing Status",
                    PluralName: "Tax Filing Statuses",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "EmploymentStatus",
                    DisplayName: "Employment Status",
                    PluralName: "Employment Statuses",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "TotalAssets",
                    DisplayName: "Total Assets",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalLiabilities",
                    DisplayName: "Total Liabilities",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalMonthlyIncome",
                    DisplayName: "Total Monthly Income",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalMonthlyExpenses",
                    DisplayName: "Total Monthly Expenses",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "AppointmentsToClientStatus",
                    DisplayName: "# of Appointments To Become Client",
                    Type: "int",
                    FilterType: "comparison"
                }
            ],
            Account: [
                {
                    Name: "Advisors",
                    ConditionName: "AdvisorIds",
                    DisplayName: "Advisors",
                    Type: "Guid",
                    FilterType: "array"
                },
                {
                    Name: "RiskTolerance",
                    DisplayName: "Risk Tolerance",
                    PluralName: "Risk Tolerances",
                    Type: "int",
                    FilterType: null
                },
                {
                    Name: "InvestmentKnowledge",
                    DisplayName: "Investment Knowledge",
                    PluralName: "Investment Knowledges",
                    Type: "int",
                    FilterType: null
                },
                //this is broken, hide for now until we figure out a fix
                //{
                //    Name: "InvestmentObjectives",
                //    DisplayName: "Investment Objectives",
                //    Type: "string",
                //    FilterType: "string"
                //},
                {
                    Name: "AccountName",
                    DisplayName: "Account Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "CaseName",
                    DisplayName: "Case Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AccountNumber",
                    DisplayName: "Account Number",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Carrier",
                    ConditionName: "CarrierId",
                    DisplayName: "Carrier",
                    PluralName: "Carriers",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "Product",
                    ConditionName: "ProductId",
                    DisplayName: "Product",
                    PluralName: "Products",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "Jurisdiction",
                    DisplayName: "Jurisdiction",
                    PluralName: "Jurisdictions",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "TaxQualification",
                    ConditionName: "TaxQualificationId",
                    DisplayName: "Tax Qualification",
                    PluralName: "Tax Qualifications",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "Owner",
                    DisplayName: "Owner",
                    Type: "string",
                    FilterType: "string",
                    Hidden: true
                },
                {
                    Name: "OwnerPrefix",
                    DisplayName: "Owner Title",
                    PluralName: "Owner Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "OwnerDob",
                    DisplayName: "Owner DOB",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "OwnerName",
                    DisplayName: "Owner Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerFirstName",
                    DisplayName: "Owner First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerLastName",
                    DisplayName: "Owner Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerPhone",
                    DisplayName: "Owner Phone",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerEmail",
                    DisplayName: "Owner Email",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerStreetAddress1",
                    DisplayName: "Owner Street Address 1",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerStreetAddress2",
                    DisplayName: "Owner Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "OwnerCity",
                    DisplayName: "Owner City",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "OwnerStateCode",
                    DisplayName: "Owner State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "OwnerPostalCode",
                    DisplayName: "Owner Zip",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointOwner",
                    DisplayName: "Joint Owner",
                    Type: "string",
                    FilterType: "string",
                    Hidden: true
                },
                {
                    Name: "JointOwnerFirstName",
                    DisplayName: "Joint Owner First Name",
                    Type: "string",
                    FilterType: "string",
                },
                {
                    Name: "JointOwnerLastName",
                    DisplayName: "Joint Owner Last Name",
                    Type: "string",
                    FilterType: "string",
                },
                {
                    Name: "JointOwnerPrefix",
                    DisplayName: "Joint Owner Title",
                    PluralName: "Joint Owner Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointOwnerDob",
                    DisplayName: "Joint Owner DOB",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "JointOwnerName",
                    DisplayName: "Joint Owner Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointOwnerPhone",
                    DisplayName: "Joint Owner Phone",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointOwnerEmail",
                    DisplayName: "Joint Owner Email",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointOwnerStreetAddress1",
                    DisplayName: "Joint Owner Street Address 1",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointOwnerStreetAddress2",
                    DisplayName: "Joint Owner Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointOwnerCity",
                    DisplayName: "Joint Owner City",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointOwnerStateCode",
                    DisplayName: "Joint Owner State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointOwnerPostalCode",
                    DisplayName: "Joint Owner Zip",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "Annuitant",
                    DisplayName: "Annuitant",
                    Type: "string",
                    FilterType: "string",
                    Hidden: true
                },
                {
                    Name: "AnnuitantPrefix",
                    DisplayName: "Annuitant Title",
                    PluralName: "Annuitant Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "AnnuitantDob",
                    DisplayName: "Annuitant DOB",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "AnnuitantName",
                    DisplayName: "Annuitant Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantFirstName",
                    DisplayName: "Annuitant First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantLastName",
                    DisplayName: "Annuitant Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantPhone",
                    DisplayName: "Annuitant Phone",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantEmail",
                    DisplayName: "Annuitant Email",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantStreetAddress1",
                    DisplayName: "Annuitant Street Address 1",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantStreetAddress2",
                    DisplayName: "Annuitant Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AnnuitantCity",
                    DisplayName: "Annuitant City",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "AnnuitantStateCode",
                    DisplayName: "Annuitant State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "AnnuitantPostalCode",
                    DisplayName: "Annuitant Zip",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointAnnuitant",
                    DisplayName: "Joint Annuitant",
                    Type: "string",
                    FilterType: "string",
                    Hidden: true
                },
                {
                    Name: "JointAnnuitantPrefix",
                    DisplayName: "Joint Annuitant Title",
                    PluralName: "Joint Annuitant Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointAnnuitantDob",
                    DisplayName: "Joint Annuitant DOB",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "JointAnnuitantName",
                    DisplayName: "Joint Annuitant Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantFirstName",
                    DisplayName: "Joint Annuitant First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantLastName",
                    DisplayName: "Joint Annuitant Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantPhone",
                    DisplayName: "Joint Annuitant Phone",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantEmail",
                    DisplayName: "Joint Annuitant Email",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantStreetAddress1",
                    DisplayName: "Joint Annuitant Street Address 1",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantStreetAddress2",
                    DisplayName: "Joint Annuitant Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointAnnuitantCity",
                    DisplayName: "Joint Annuitant City",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointAnnuitantStateCode",
                    DisplayName: "Joint Annuitant State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointAnnuitantPostalCode",
                    DisplayName: "Joint Annuitant Zip",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "Insured",
                    DisplayName: "Insured",
                    Type: "string",
                    FilterType: "string",
                    Hidden: true
                },
                {
                    Name: "InsuredPrefix",
                    DisplayName: "Insured Title",
                    PluralName: "Insured Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "InsuredDob",
                    DisplayName: "Insured DOB",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "InsuredName",
                    DisplayName: "Insured Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredFirstName",
                    DisplayName: "Insured First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredLastName",
                    DisplayName: "Insured Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredPhone",
                    DisplayName: "Insured Phone",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredEmail",
                    DisplayName: "Insured Email",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredStreetAddress1",
                    DisplayName: "Insured Street Address 1",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredStreetAddress2",
                    DisplayName: "Insured Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InsuredCity",
                    DisplayName: "Insured City",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "InsuredStateCode",
                    DisplayName: "Insured State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "InsuredPostalCode",
                    DisplayName: "Insured Zip",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointInsured",
                    DisplayName: "Joint Insured",
                    Type: "string",
                    FilterType: "string",
                    Hidden: true
                },
                {
                    Name: "JointInsuredPrefix",
                    DisplayName: "Joint Insured Title",
                    PluralName: "Joint Insured Titles",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointInsuredDob",
                    DisplayName: "Joint Insured DOB",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "JointInsuredName",
                    DisplayName: "Joint Insured Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredFirstName", 
                    DisplayName: "Joint Insured First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredLastName",
                    DisplayName: "Joint Insured Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredPhone",
                    DisplayName: "Joint Insured Phone",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredEmail",
                    DisplayName: "Joint Insured Email",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredStreetAddress1",
                    DisplayName: "Joint Insured Street Address 1",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredStreetAddress2",
                    DisplayName: "Joint Insured Street Address 2",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "JointInsuredCity",
                    DisplayName: "Joint Insured City",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointInsuredStateCode",
                    DisplayName: "Joint Insured State",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "JointInsuredPostalCode",
                    DisplayName: "Joint Insured Zip",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "Beneficiaries",
                    DisplayName: "Beneficiaries",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "ContingentBeneficiaries",
                    DisplayName: "Contingent Beneficiaries",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "InvestmentAccountType",
                    ConditionName: "InvestmentAccountId",
                    DisplayName: "Investment Account Type",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "Custodian",
                    CustodianName: "CustodianId",
                    DisplayName: "Custodian",
                    PluralName: "Custodians",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "TotalEstimatedPremium",
                    DisplayName: "Total Estimated Premium",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "TotalIssuedPremium",
                    DisplayName: "Total Issued Premium",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "AccountValue",
                    DisplayName: "Account Value",
                    Type: "decimal",
                    FilterType: "comparison"
                },
                {
                    Name: "AccountValueUpdatedOn",
                    DisplayName: "Latest Account Value Updated Date",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "LatestAccountStatus",
                    DisplayName: "Latest Account Status",
                    PluralName: "Account Statuses",
                    Type: "string",
                    FilterType: null
                },
                {
                    Name: "LatestAccountStatusDate",
                    DisplayName: "Latest Account Status Date",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "SurrenderDate",
                    DisplayName: "Surrender Date",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "LineOfBusiness",
                    DisplayName: "Line of Business",
                    Type: "string",
                    FilterType: null
                }
            ],
            Appointment: [
                {
                    Name: "FirstName",
                    DisplayName: "Attendee's First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "MiddleName",
                    DisplayName: "Attendee's Middle Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "LastName",
                    DisplayName: "Attendee's Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Nickname",
                    DisplayName: "Attendee's Nickname",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "TotalCases",
                    DisplayName: "Total Cases",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "AssignedUsers",
                    ConditionName: "AssignedUserIds",
                    DisplayName: "Assigned Users",
                    Type: "Guid",
                    FilterType: "array"
                },
                {
                    Name: "Subject",
                    DisplayName: "Subject",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Location",
                    DisplayName: "Location",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "LatestNote",
                    DisplayName: "Latest Note",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "StartDate",
                    DisplayName: "Start Date",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "EndDate",
                    DisplayName: "End Date",
                    Type: "DateTime",
                    FilterType: "comparison"
                }
            ],
            ScheduledTask: [
                {
                    Name: "FirstName",
                    DisplayName: "Client's First Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "MiddleName",
                    DisplayName: "Client's Middle Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "LastName",
                    DisplayName: "Client's Last Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "Nickname",
                    DisplayName: "Client's Nickname",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "TotalCases",
                    DisplayName: "Total Cases",
                    Type: "int",
                    FilterType: "comparison"
                },
                {
                    Name: "Name",
                    DisplayName: "Scheduled Task Name",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "LatestNote",
                    DisplayName: "Latest Note",
                    Type: "string",
                    FilterType: "string"
                },
                {
                    Name: "AssignedTo",
                    ConditionName: "AssignedToId",
                    DisplayName: "Assigned To",
                    PluralName: "Users",
                    Type: "Guid",
                    FilterType: null
                },
                {
                    Name: "DueDate",
                    DisplayName: "Due Date",
                    Type: "DateTime",
                    FilterType: "comparison"
                },
                {
                    Name: "Status",
                    DisplayName: "Status",
                    PluralName: "Statuses",
                    Type: "string",
                    FilterType: null
                }
            ],
            ClientReferral: [
                {
                    Name: "DateReferredOn",
                    DisplayName: "Date Referred",
                    Type: "DateTime",
                    FilterType: "comparison",
                    GroupType: "Referral"
                },
                {
                    Name: "RefereeFirstName",
                    DisplayName: "First Name (Referral)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Referral"
                },
                {
                    Name: "RefereeLastName",
                    DisplayName: "Last Name (Referral)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Referral"
                },
                {
                    Name: "RefereeStatus",
                    ConditionName: "RefereeStatusId",
                    DisplayName: "Status (Referral)",
                    PluralName: "Statuses (Referral)",
                    Type: "Guid",
                    FilterType: null,
                    GroupType: "Referral"
                },
                {
                    Name: "ReferrerFirstName",
                    DisplayName: "First Name (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerMiddleName",
                    DisplayName: "Middle Name (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerLastName",
                    DisplayName: "Last Name (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerNickname",
                    DisplayName: "Nickname (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerAge",
                    DisplayName: "Age (Contact)",
                    Type: "int",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerDateOfBirth",
                    DisplayName: "Date Of Birth (Contact)",
                    Type: "DateTime",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerAdvisor",
                    ConditionName: "ReferrerAdvisorId",
                    DisplayName: "Advisor (Contact)",
                    PluralName: "Advisors (Contact)",
                    Type: "Guid",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerPhoneNumber",
                    DisplayName: "Phone Number (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerEmailAddress",
                    DisplayName: "Email Address (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerPhysicalAddress",
                    DisplayName: "Full Physical Address (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerStreetAddress1",
                    DisplayName: "Street Address (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerStreetAddress2",
                    DisplayName: "Street Address 2 (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerCity",
                    DisplayName: "City (Contact)",
                    PluralName: "Cities (Contact)",
                    Type: "string",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerStateCode",
                    DisplayName: "State (Contact)",
                    Type: "string",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerPostalCode",
                    DisplayName: "Zip (Contact)",
                    Type: "string",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerAum",
                    DisplayName: "AUM (Contact)",
                    Type: "decimal",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalIssuedPremium",
                    DisplayName: "Total Issued Premium (Contact)",
                    Type: "decimal",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalCases",
                    DisplayName: "Total Cases (Contact)",
                    Type: "int",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalTasks",
                    DisplayName: "Total Tasks (Contact)",
                    Type: "int",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalAppointments",
                    DisplayName: "Total Appointments (Contact)",
                    Type: "int",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTags",
                    DisplayName: "Tags (Contact)",
                    Type: "string",
                    FilterType: "array",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerGender",
                    DisplayName: "Gender (Contact)",
                    PluralName: "Genders (Contact)",
                    Type: "string",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerSsn",
                    DisplayName: "SSN (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerOccupation",
                    DisplayName: "Occupation (Contact)",
                    Type: "string",
                    FilterType: "string",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerStatus",
                    ConditionName: "ReferrerStatusId",
                    DisplayName: "Status (Contact)",
                    PluralName: "Statuses (Contact)",
                    Type: "Guid",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTaxBracket",
                    DisplayName: "Tax Bracket (Contact)",
                    Type: "int",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTaxFilingStatus",
                    DisplayName: "Tax Filing Status (Contact)",
                    PluralName: "Tax Filing Statuses (Contact)",
                    Type: "string",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerEmploymentStatus",
                    DisplayName: "Employment Status (Contact)",
                    PluralName: "Employment Statuses (Contact)",
                    Type: "string",
                    FilterType: null,
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalAssets",
                    DisplayName: "Total Assets (Contact)",
                    Type: "decimal",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalLiabilities",
                    DisplayName: "Total Liabilities (Contact)",
                    Type: "decimal",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalMonthlyIncome",
                    DisplayName: "Total Monthly Income (Contact)",
                    Type: "decimal",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerTotalMonthlyExpenses",
                    DisplayName: "Total Monthly Expenses (Contact)",
                    Type: "decimal",
                    FilterType: "comparison",
                    GroupType: "Contact"
                },
                {
                    Name: "ReferrerAppointmentsToClientStatus",
                    DisplayName: "# of Appointments To Become Client (Contact)",
                    Type: "int",
                    FilterType: "comparison",
                    GroupType: "Contact"
                }
            ]
        });

})(window.app); //jshint ingore:line